import { useNavigationManager } from '@provider/navigation';
import { SupportIcon } from '@ui/kit';
import { useMatchBreakpoint, Chevron } from '@utils/react';
import { userAreaBreakpoints } from '../../../const.breakpoints.js';
import { headerCls, headingCls } from '../../../layout/content.style.js';
import { supportCls, supportIconCls } from './atom.header.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const StatusHeader = () => {
  const isMobile = useMatchBreakpoint(userAreaBreakpoints.mobile);
  const navigation = useNavigationManager();
  return /*#__PURE__*/jsxs("header", {
    className: headerCls,
    children: [/*#__PURE__*/jsx("h1", {
      className: headingCls,
      children: isMobile ? /*#__PURE__*/jsxs("button", {
        "aria-label": "G\xE5 tilbage til oversigt",
        onClick: () => navigation.push("/"),
        children: [/*#__PURE__*/jsx(Chevron, {
          inversed: true,
          size: 12
        }), "Teknisk support"]
      }) : "Teknisk support"
    }), /*#__PURE__*/jsxs("a", {
      className: supportCls,
      href: `${process.env["GU_URL"]}/kundeservice/teknisk-support`,
      target: "_blank",
      rel: "noreferrer",
      children: [/*#__PURE__*/jsx("span", {
        className: supportIconCls,
        children: /*#__PURE__*/jsx(SupportIcon, {})
      }), "Skriv til support"]
    })]
  });
};

export { StatusHeader };
//# sourceMappingURL=atom.header.js.map
